var _path, _mask, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31053 0.75H18.0604C18.8889 0.75 19.5604 1.42157 19.5604 2.24999C19.5604 3.07841 18.8889 3.74998 18.0604 3.74998H2.31053C1.48211 3.74998 0.810547 3.07841 0.810547 2.24999C0.810547 1.42157 1.48211 0.75 2.31053 0.75Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_610_3390",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.31055 4.5V15.7499C2.31055 16.3467 2.5476 16.919 2.96955 17.3409C3.39151 17.7629 3.9638 17.9999 4.56053 17.9999H15.8105C16.4072 17.9999 16.9795 17.7629 17.4015 17.3409C17.8234 16.919 18.0605 16.3467 18.0605 15.7499V4.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81055 4.5C3.81055 3.67157 3.13897 3 2.31055 3C1.48212 3 0.810547 3.67157 0.810547 4.5H3.81055ZM2.31055 15.7499H0.810547H2.31055ZM19.5605 4.5C19.5605 3.67157 18.8889 3 18.0605 3C17.232 3 16.5605 3.67157 16.5605 4.5H19.5605ZM0.810547 4.5V15.7499H3.81055V4.5H0.810547ZM0.810547 15.7499C0.810547 16.7445 1.20563 17.6983 1.90889 18.4016L4.03021 16.2803C3.88956 16.1396 3.81055 15.9488 3.81055 15.7499H0.810547ZM1.90889 18.4016C2.61215 19.1048 3.56598 19.4999 4.56053 19.4999V16.4999C4.36163 16.4999 4.17086 16.4209 4.03021 16.2803L1.90889 18.4016ZM4.56053 19.4999H15.8105V16.4999H4.56053V19.4999ZM15.8105 19.4999C16.805 19.4999 17.7589 19.1048 18.4621 18.4016L16.3408 16.2803C16.2001 16.4209 16.0094 16.4999 15.8105 16.4999V19.4999ZM18.4621 18.4016C19.1654 17.6983 19.5605 16.7445 19.5605 15.7499H16.5605C16.5605 15.9488 16.4814 16.1396 16.3408 16.2803L18.4621 18.4016ZM19.5605 15.7499V4.5H16.5605V15.7499H19.5605Z",
    fill: "#333333",
    mask: "url(#path-2-inside-1_610_3390)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0571 8V13.5928",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8535 10.7959L10.0571 13.5923L7.26074 10.7959",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.c52df903d7ebf52451ff6d314c525852.svg";
export { ForwardRef as ReactComponent };